import countries from 'config/countries.json';

const getDefaultValueInSelect = (value) => {
    const selected = countries.filter((country) => country.code.toLowerCase() === value.toLowerCase());

    return {
        value: selected[0].code,
        label: selected[0].name_pl,
    };
};

export default getDefaultValueInSelect;
